// extracted by mini-css-extract-plugin
module.exports = {"aboutOurMainContainer":"aboutOur_aboutOurMainContainer__ofK9u","aboutOurContainer":"aboutOur_aboutOurContainer__oXCc4"};